import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Projects } from './components/Projects';
import { CV } from './components/CV';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-black min-h-screen w-full" data-id="element-0">
      {/* Background image with overlay */}
      <div className="fixed inset-0 z-0 opacity-30" style={{
      backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/pNjFJhMSWw5jM8hjSpF6ii/fd3e4b1863875921.66abb2ffdc0cc_1_%281%29.png')`,
      backgroundSize: '400px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-1" />
      {/* Animated stars background */}
      <div className="fixed inset-0 z-0 bg-gradient-to-b from-black to-purple-950 opacity-90" data-id="element-2" />
      {/* Content */}
      <div className="relative z-1" data-id="element-3">
        <Header data-id="element-4" />
        <Hero data-id="element-5" />
        <About data-id="element-6" />
        <Projects data-id="element-7" />
        <CV data-id="element-8" />
        <Contact data-id="element-9" />
        <Footer data-id="element-10" />
      </div>
    </div>;
}